// Vorschaubild eines Fotos: bevorzugt aus dem lokalen Speicher (geht auch
// offline), sonst über die Server-URL.

import { useEffect, useState } from "react";
import { BLUR_MIN, BRIGHTNESS_MAX, BRIGHTNESS_MIN } from "@umzugsscan/shared";
import { useStore } from "../hooks.ts";
import type { Photo } from "../zustand.ts";

export function usePhotoUrl(photo: Photo): string | null {
  const store = useStore();
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let objectUrl: string | null = null;
    let alive = true;
    void store.photoBlob(photo.id).then((blob) => {
      if (!alive) return;
      if (blob) {
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      } else {
        setUrl(photo.url);
      }
    });
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [store, photo.id, photo.url]);
  return url;
}

// Helligkeit vor Schärfe: Ein dunkles Foto hat auch wenig Kontrast und
// gälte sonst als "unscharf" – der hilfreichere Rat ist aber "Licht an".
export function qualityIssue(p: Photo): string | null {
  // Lampenfotos: glatte Decke (wenig Kanten) und leuchtende Lampe – Schärfe und Helligkeit sagen hier nichts (15.10.2026).
  if (p.step === "lampe") return null;
  if (p.brightness !== null && p.brightness < BRIGHTNESS_MIN) return "zu dunkel";
  if (p.brightness !== null && p.brightness > BRIGHTNESS_MAX) return "zu hell";
  if (p.blurScore !== null && p.blurScore < BLUR_MIN) return "unscharf";
  return null;
}

export function Vorschau(props: { photo: Photo; onDelete?: () => void; onClick?: () => void }) {
  const url = usePhotoUrl(props.photo);
  const issue = qualityIssue(props.photo);
  return (
    <figure className={`thumb${issue ? " thumb-warn" : ""}`}>
      <button type="button" className="thumb-img" onClick={props.onClick} disabled={!props.onClick} aria-label="Foto öffnen">
        {url ? <img src={url} alt="" loading="lazy" /> : <span className="thumb-empty" />}
      </button>
      {issue && <span className="badge badge-warn">{issue}</span>}
      {props.photo.marks.length > 0 && <span className="badge badge-mark">{props.photo.marks.length}</span>}
      {!props.photo.uploaded && <span className="badge badge-wait" title="Wird übertragen">⏳</span>}
      {props.onDelete && (
        <button type="button" className="thumb-del" aria-label="Foto löschen" onClick={props.onDelete}>
          ×
        </button>
      )}
    </figure>
  );
}
